var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrownIconPremium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7299_4998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 26.6838C20.7812 26.6838 26.6837 20.7812 26.6837 13.5001C26.6837 6.21894 20.7812 0.316406 13.5001 0.316406C6.21894 0.316406 0.316406 6.21894 0.316406 13.5001C0.316406 20.7812 6.21894 26.6838 13.5001 26.6838Z",
    fill: "url(#paint0_linear_7299_4998)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08594 17.2703H18.9143V18.9174H8.08594V17.2703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5168 10.0381C11.786 10.0381 12.0043 10.2564 12.0043 10.5256C12.0043 10.7949 11.786 11.0131 11.5168 11.0131C11.2476 11.0131 11.0293 10.7949 11.0293 10.5256C11.0293 10.2564 11.2476 10.0381 11.5168 10.0381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30587 11.3326C7.53628 11.3326 7.72309 11.5193 7.72309 11.7498C7.72309 11.9802 7.53628 12.167 7.30587 12.167C7.07545 12.167 6.88867 11.9802 6.88867 11.7498C6.88867 11.5193 7.07545 11.3326 7.30587 11.3326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4836 10.0381C15.2144 10.0381 14.9961 10.2564 14.9961 10.5256C14.9961 10.7949 15.2144 11.0131 15.4836 11.0131C15.7528 11.0131 15.9711 10.7949 15.9711 10.5256C15.9711 10.2564 15.7528 10.0381 15.4836 10.0381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6946 11.3326C19.4641 11.3326 19.2773 11.5193 19.2773 11.7498C19.2773 11.9802 19.4641 12.167 19.6946 12.167C19.925 12.167 20.1118 11.9802 20.1118 11.7498C20.1118 11.5193 19.925 11.3326 19.6946 11.3326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5001 8.08252C13.7968 8.08252 14.0373 8.32302 14.0373 8.61971C14.0373 8.82763 13.9192 9.00795 13.7464 9.09725L13.7413 9.09983C13.6688 9.13633 13.5868 9.15692 13.5001 9.15692C13.4134 9.15692 13.3314 9.13633 13.2589 9.09982L13.2538 9.09726C13.081 9.00795 12.9629 8.82763 12.9629 8.61971C12.9629 8.32302 13.2034 8.08252 13.5001 8.08252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48822 9.64957C8.74491 9.64957 8.95301 9.85766 8.95301 10.1144C8.95301 10.371 8.74491 10.5791 8.48822 10.5791C8.23153 10.5791 8.02344 10.371 8.02344 10.1144C8.02344 9.85766 8.23153 9.64957 8.48822 9.64957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49016 11.809C5.74687 11.809 5.95494 12.0171 5.95494 12.2738C5.95494 12.5305 5.74687 12.7386 5.49016 12.7386C5.23348 12.7386 5.02539 12.5305 5.02539 12.2738C5.02539 12.0171 5.23348 11.809 5.49016 11.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5136 9.64957C18.2569 9.64957 18.0488 9.85766 18.0488 10.1144C18.0488 10.371 18.2569 10.5791 18.5136 10.5791C18.7703 10.5791 18.9784 10.371 18.9784 10.1144C18.9784 9.85766 18.7703 9.64957 18.5136 9.64957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5117 11.809C21.255 11.809 21.0469 12.0171 21.0469 12.2738C21.0469 12.5305 21.255 12.7386 21.5117 12.7386C21.7684 12.7386 21.9764 12.5305 21.9764 12.2738C21.9764 12.0171 21.7684 11.809 21.5117 11.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.677 10.9345C8.98891 11.7033 9.17035 13.0342 9.23341 13.7066C9.26963 14.5517 8.37025 13.9904 8.37025 13.9904C7.65936 13.6261 6.92303 13.1106 6.25979 12.6146C6.18237 12.7891 6.04736 12.9323 5.87891 13.0202C7.57237 14.6346 8.08656 16.8937 8.08656 16.8937H18.9149C18.9149 16.8937 19.4291 14.6346 21.1225 13.0202C20.9541 12.9323 20.8191 12.7891 20.7417 12.6146C20.0784 13.1106 19.342 13.6261 18.6312 13.9904C18.6312 13.9904 17.7318 14.5517 17.768 13.7066C17.8311 13.0342 18.0125 11.7033 18.3244 10.9345C18.1143 10.8862 17.9341 10.7591 17.8167 10.5861C17.027 11.3539 16.2075 12.2423 15.6003 13.1229C15.6003 13.1229 15.1235 13.7386 14.7613 13.1229C14.4175 12.5382 13.9279 10.5071 13.8058 9.4814C13.7081 9.51602 13.605 9.53358 13.5007 9.53358C13.3964 9.53358 13.2933 9.51595 13.1957 9.48135C13.0735 10.5071 12.584 12.5382 12.2401 13.1229C11.878 13.7386 11.4011 13.1229 11.4011 13.1229C10.794 12.2423 9.97443 11.3539 9.18477 10.5861C9.06736 10.7591 8.8872 10.8862 8.677 10.9345ZM9.3191 15.9839C9.3191 15.8798 9.40342 15.7955 9.50743 15.7955H17.494C17.598 15.7955 17.6824 15.8798 17.6824 15.9839C17.6824 16.0879 17.598 16.1722 17.494 16.1722H9.50743C9.40342 16.1722 9.3191 16.0879 9.3191 15.9839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00215 12.1327C7.90737 12.3045 7.75082 12.4374 7.5625 12.5015C7.76303 12.8779 7.87846 13.2811 7.92249 13.4538C7.99348 13.4927 8.0643 13.5304 8.13488 13.5666C8.13488 13.5666 9.03426 14.1279 8.99804 13.2829C8.99424 13.2424 8.99002 13.1996 8.98537 13.1546C8.80603 12.9413 8.40199 12.4774 8.00215 12.1327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9989 12.1327C18.5991 12.4774 18.195 12.9413 18.0157 13.1546C18.011 13.1995 18.0068 13.2424 18.003 13.2829C17.9668 14.1279 18.8662 13.5666 18.8662 13.5666C18.9368 13.5304 19.0076 13.4927 19.0786 13.4538C19.1226 13.2811 19.238 12.8779 19.4386 12.5015C19.2502 12.4374 19.0937 12.3045 18.9989 12.1327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.891 11.3053C11.778 11.3595 11.6515 11.3898 11.518 11.3898C11.4462 11.3898 11.3765 11.3811 11.3098 11.3645C11.3139 11.9279 11.2261 12.2904 11.1719 12.4597C11.2182 12.5238 11.2635 12.5879 11.3077 12.652C11.3077 12.652 11.7846 13.2677 12.1467 12.652C12.1984 12.5641 12.2534 12.4435 12.3099 12.2986C12.2397 12.1873 12.0008 11.7855 11.891 11.3053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1104 11.3053C15.0006 11.7855 14.7616 12.1873 14.6914 12.2986C14.7479 12.4435 14.8029 12.5641 14.8546 12.652C15.2168 13.2677 15.6936 12.652 15.6936 12.652C15.7378 12.5879 15.7831 12.5238 15.8295 12.4597C15.7753 12.2904 15.6874 11.9279 15.6915 11.3645C15.6248 11.3811 15.5551 11.3898 15.4834 11.3898C15.3498 11.3898 15.2233 11.3595 15.1104 11.3053Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7299_4998",
    x1: 4.00787,
    y1: 22.9923,
    x2: 22.9923,
    y2: 4.00787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470588,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7299_4998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIconPremium);
export default __webpack_public_path__ + "static/media/crownIconPremium.31bed33a8cd1e77b2c462fe35734a8fd.svg";
export { ForwardRef as ReactComponent };